module.exports = __webpack_public_path__ + "img/code.bab820e6.png";